<template>
  <div class="dashboard">
    <DashboardUnAuth v-if="!$store.state.session.tenant" />

    <template v-else>
      <div class="PageHeader">
        <el-breadcrumb>
          <el-breadcrumb-item>{{ l("总览") }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="PageContent">
        <TenantManagerInfo />
        <div class="cardContainer">
          <div class="card">
            <div class="header">
              <span><i class="el-icon-box"></i>{{ l("现货卖场") }}</span>
              <div
                class="more"
                @click="$router.push({ path: '/backend/seller_quotation' })"
              >
                {{ l("全部") }}
                <i class="el-icon-arrow-right"></i>
              </div>
            </div>
            <div class="countContainer">
              <div
                class="countItem"
                @click="
                  $router.push({
                    path: '/backend/seller_quotation',
                    query: { status: 1 },
                  })
                "
              >
                <div class="text">{{ l("已上架") }}</div>
                <div>
                  {{ tenant_business_count.quotation.on }}
                </div>
              </div>
              <div class="splitLine"></div>
              <div
                class="countItem"
                @click="
                  $router.push({
                    path: '/backend/seller_quotation',
                    query: { status: 0 },
                  })
                "
              >
                <div class="text">{{ l("审核中") }}</div>
                <div>
                  {{ tenant_business_count.quotation.verify }}
                </div>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="header">
              <span>
                <i class="el-icon-cpu"></i>
                {{ l("锻件定制") }}
              </span>
              <div
                class="more"
                @click="
                  $router.push({ path: '/backend/buyer_purchase_forging' })
                "
              >
                {{ l("全部") }}
                <i class="el-icon-arrow-right"></i>
              </div>
            </div>
            <div class="countContainer">
              <div
                class="countItem"
                @click="
                  $router.push({
                    path: '/backend/buyer_purchase_forging',
                    query: { status: 1 },
                  })
                "
              >
                <div class="text">{{ l("已上架") }}</div>
                <div>
                  {{ tenant_business_count.purchase_forging.on }}
                </div>
              </div>
              <div class="splitLine"></div>
              <div
                class="countItem"
                @click="
                  $router.push({
                    path: '/backend/buyer_purchase_forging',
                    query: { status: 0 },
                  })
                "
              >
                <div class="text">{{ l("审核中") }}</div>
                <div>
                  {{ tenant_business_count.purchase_forging.verify }}
                </div>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="header">
              <span>
                <i class="el-icon-shopping-cart-2"></i>
                {{ l("原料求购") }}
              </span>
              <div
                class="more"
                @click="
                  $router.push({ path: '/backend/buyer_purchase_material' })
                "
              >
                {{ l("全部") }}
                <i class="el-icon-arrow-right"></i>
              </div>
            </div>
            <div class="countContainer">
              <div
                class="countItem"
                @click="
                  $router.push({
                    path: '/backend/buyer_purchase_material',
                    query: { status: 1 },
                  })
                "
              >
                <div class="text">{{ l("已上架") }}</div>
                <div>
                  {{ tenant_business_count.purchase_material.on }}
                </div>
              </div>
              <div class="splitLine"></div>
              <div
                class="countItem"
                @click="
                  $router.push({
                    path: '/backend/buyer_purchase_material',
                    query: { status: 0 },
                  })
                "
              >
                <div class="text">{{ l("审核中") }}</div>
                <div>
                  {{ tenant_business_count.purchase_material.verify }}
                </div>
              </div>
            </div>
          </div>
          <div class="card">
            <div class="header">
              <span>
                <i class="el-icon-shopping-cart-1"></i>
                {{ l("零切交易") }}
              </span>
              <div
                class="more"
                @click="$router.push({ path: '/backend/buyer_purchase_piece' })"
              >
                {{ l("全部") }}
                <i class="el-icon-arrow-right"></i>
              </div>
            </div>
            <div class="countContainer">
              <div
                class="countItem"
                @click="
                  $router.push({
                    path: '/backend/buyer_purchase_piece',
                    query: { status: 1 },
                  })
                "
              >
                <div class="text">{{ l("已上架") }}</div>
                <div>
                  {{ tenant_business_count.purchase_piece.on }}
                </div>
              </div>
              <div class="splitLine"></div>
              <div
                class="countItem"
                @click="
                  $router.push({
                    path: '/backend/buyer_purchase_piece',
                    query: { status: 0 },
                  })
                "
              >
                <div class="text">{{ l("审核中") }}</div>
                <div>
                  {{ tenant_business_count.purchase_piece.verify }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 
        <div
          v-if="$store.state.session.tenant"
          class="businessContainer"
        >
          <div class="header">
            <el-image
              :src="GetResourceUrl('backend/icon-business2me.svg')"
              fit="contain"
            >
            </el-image>
            {{ l("意向客户") }}
          </div>
          <BusinessList
            :targetMode="1"
            api_url="/api/business_action/to_me_list/?status=1"
          />
        </div> -->

        <div v-if="$store.state.session.tenant" class="businessContainer">
          <div class="header">
            <el-image
              :src="GetResourceUrl('backend/icon-business.svg')"
              fit="contain"
            >
            </el-image>
            {{ l("我的意向") }}
          </div>
          <BusinessList
            api_url="/api/business_action/"
            :fromMe="true"
            :targetMode="1"
          />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import DashboardUnAuth from "./DashboardUnAuth.vue";
import TenantManagerInfo from "./TenantManagerInfo.vue";
import BusinessList from "@/components/common/BusinessList.vue";

export default {
  name: "Dashboard",
  components: {
    DashboardUnAuth,
    TenantManagerInfo,
    BusinessList,
  },
  data() {
    return {
      tenant_business_count: {
        quotation: {
          all: 0,
          verify: 0,
          on: 0,
        },
        purchase_material: {
          all: 0,
          verify: 0,
          on: 0,
        },
        purchase_piece: {
          all: 0,
          verify: 0,
          on: 0,
        },
        purchase_forging: {
          all: 0,
          verify: 0,
          on: 0,
        },
      },
    };
  },

  mounted() {
    this.$store.dispatch("updateSession").then(() => {
      //已完成企业认证
      if (this.$store.state.session.tenant) {
        this.getCounts();
      }
    });
    console.log(this.$route);
  },
  methods: {
    getCounts() {
      this.axios.get("/api/tenant_business_count/").then((data) => {
        this.tenant_business_count = data;
      });
    },
  },
};
</script>

<style scoped lang="scss">
.dashboard {
  background: #f1f1f1 !important;
  .PageContent {
    padding: 0%;
  }
  .infoContainer {
    height: 168px;
    box-sizing: border-box;
    padding: 30px 40px;
    display: flex;
    justify-content: space-between;
    background: #fff;
    flex-grow: 1;
    .companyInfo {
      display: flex;
      justify-content: space-between;
      flex-direction: column;
      font-size: 14px;
      box-sizing: border-box;
      padding: 10px 0;

      .type_tag {
        border-radius: 4px;
        font-size: 12px;
        padding: 2px 8px;
        border: 1px solid #fef2da;
        color: #f86a34;
        background: #fffbf2;
        margin-left: 6px;
        flex-shrink: 0;
      }
    }
    .managerInfo {
      width: 332px;
      height: 108px;
      box-sizing: border-box;
      background: $warningPlainColor;
      border: 1px solid $warningColor;
      box-sizing: border-box;
      border-radius: 6px;
      position: relative;
      display: flex;
      // justify-content: space-between;
      align-items: center;
      flex-shrink: 0;

      .label {
        background: $warningColor;
        display: flex;
        align-items: center;
        justify-content: center;
        color: $warningPlainColor;
        position: absolute;
        width: 108px;
        height: 30px;
        right: -1px;
        top: -1px;
        font-size: 12px;
        border-top-right-radius: 6px;
        border-bottom-left-radius: 10px;
        .el-image {
          margin-right: 2px;
          width: 12px;
          height: 12px;
        }
      }
      .detail {
        margin-left: 20px;
        i {
          color: $warningColor;
        }
      }
    }
  }
  .cardContainer {
    // width: 320px;
    display: flex;
    justify-content: space-between;
    .card {
      width: 24%;
      background-color: #fff;
      margin-top: 15px;
      box-sizing: border-box;
      padding: 20px;
      height: 140px;

      .more {
        cursor: pointer;
        font-size: 12px;
        color: #999;
      }
      .header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        span {
          font-weight: bold;
          i {
            font-size: 16px;
            color: $warningColor;
            margin-right: 6px;
          }
        }
      }
      .countContainer {
        margin-top: 22px;
        display: flex;
        justify-content: space-around;
        align-items: center;
        text-align: center;

        .countItem {
          cursor: pointer;
          .text {
            font-size: 12px;
            margin-bottom: 18px;
            + div {
              font-size: 20px;
            }
          }

          + .splitLine {
            border-left: 1px solid $borderPlainColor;
            height: 55px;
          }
        }
      }
    }
  }

  .businessContainer {
    width: 100%;
    background: #fff;
    margin-top: 15px;
    padding-bottom: 20px;
    .header {
      padding: 18px 0;
      margin: 0 20px;
      display: flex;
      align-items: center;
      font-weight: bold;
      border-bottom: 1px solid $borderPlainColor;
      .el-image {
        width: 16px;
        height: 16px;
        margin-right: 6px;
      }
    }
  }
}
</style>

